export default {
  name: 'OnboardingAiPanel',
  props: {
    mobile_open: {
      type: Boolean,
      default: false
    },
    summary_label: {
      type: String,
      default: 'Briefing'
    },
    summary_intro: {
      type: String,
      default: ''
    },
    briefing_body: {
      type: String,
      default: ''
    },
    briefing_meta: {
      type: String,
      default: ''
    },
    suggested_questions: {
      type: Array,
      default: () => []
    },
    recent_evidence: {
      type: Array,
      default: () => []
    },
    input_placeholder: {
      type: String,
      default: 'Ask about any onboarding, gate or template...'
    }
  },
  data: () => ({
    is_mobile_panel_view: window.innerWidth < 1200,
    is_collapsed: true,
    is_fullscreen: false,
    draft_question: ''
  }),
  computed: {
    panel_classes() {
      return {
        'is-mobile-view': this.is_mobile_panel_view,
        'is-collapsed': this.is_collapsed,
        'is-fullscreen': this.is_fullscreen
      };
    },
    expand_label() {
      return this.is_fullscreen ? 'Exit fullscreen' : 'Fullscreen';
    },
    resolved_summary_intro() {
      return this.summary_intro || 'Onboarding activity is live across the current workspace.';
    },
    resolved_briefing_body() {
      return this.briefing_body || 'Use this panel to focus the next action, investigate blockers and review the most recent onboarding evidence.';
    },
    resolved_briefing_meta() {
      return this.briefing_meta || 'Live panel ready';
    },
    resolved_questions() {
      return this.suggested_questions.length
        ? this.suggested_questions
        : [
            'Which onboarding needs attention first?',
            'What is blocking activation?',
            'Which document is due next?'
          ];
    }
  },
  mounted() {
    this.sync_panel_viewport_state();
    window.addEventListener('resize', this.sync_panel_viewport_state);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.sync_panel_viewport_state);
  },
  methods: {
    sync_panel_viewport_state() {
      this.is_mobile_panel_view = window.innerWidth < 1200;

      if (this.is_fullscreen) {
        return;
      }

      this.is_collapsed = this.is_mobile_panel_view ? !this.mobile_open : true;
    },
    toggle_collapsed() {
      if (this.is_fullscreen) {
        this.is_fullscreen = false;
      }

      if (this.is_mobile_panel_view) {
        this.$emit('close-mobile-panel');
        return;
      }

      this.is_collapsed = !this.is_collapsed;
    },
    toggle_fullscreen() {
      if (!this.is_fullscreen) {
        this.is_collapsed = false;
      }

      this.is_fullscreen = !this.is_fullscreen;

      if (!this.is_fullscreen && this.is_mobile_panel_view) {
        this.$emit('close-mobile-panel');
      }
    },
    queue_question(question) {
      this.draft_question = String(question || '').trim();
      this.$emit('question-selected', this.draft_question);
    },
    submit_question() {
      const question = String(this.draft_question || '').trim();
      if (!question) {
        return;
      }

      this.$emit('submit-question', question);
    },
    evidence_badge_class(tone) {
      if (tone === 'success') {
        return 'bg-success-subtle text-success-emphasis';
      }

      if (tone === 'warning') {
        return 'bg-warning-subtle text-warning-emphasis';
      }

      if (tone === 'danger') {
        return 'bg-danger-subtle text-danger-emphasis';
      }

      return 'bg-secondary-subtle text-secondary-emphasis';
    },
    evidence_icon_class(tone) {
      if (tone === 'success') {
        return 'text-success bg-success-subtle';
      }

      if (tone === 'warning') {
        return 'text-warning bg-warning-subtle';
      }

      if (tone === 'danger') {
        return 'text-danger bg-danger-subtle';
      }

      return 'text-secondary bg-secondary-subtle';
    }
  },
  watch: {
    mobile_open: {
      immediate: true,
      handler(is_open) {
        if (!this.is_mobile_panel_view || this.is_fullscreen) {
          return;
        }

        this.is_collapsed = !is_open;
      }
    },
    briefing_meta() {
      if (this.is_fullscreen || this.is_mobile_panel_view) {
        return;
      }

      this.is_collapsed = true;
    }
  }
};
